import React, { Component } from 'react';
import './Cell.css';

class Cell extends Component {
  render() {
    return (
      <div className={ `Cell ${this.props.owner} h-${this.props.currentPlayer}` } onClick={ this.props.onClick }></div>
    );
  }
}

export default Cell;



// WEBPACK FOOTER //
// ./src/Game/Cell/Cell.js